import Vue from 'vue'
import store from '@/store'
import VueRouter from 'vue-router'
import { publicPath, routerMode } from '@/config'

Vue.use(VueRouter)

// 通用路由
export const constantRoutes = [
  {
    path: '/401',
    name: '401',
    component: () => import('@/views/401'),
    hidden: true,
  },
  {
    path: '/default',
    name: 'default',
    component: () => import('@/views/default'),
    hidden: true,
  },
  {
    path: '/flowChart',
    name: 'flowChart',
    component: () => import('@/views/flowChart'),
    hidden: true,
  },
  // 审批记录
  {
    path: '/processRecord',
    name: 'processRecord',
    component: () => import('@/views/processRecord'),
    hidden: true,
  },
  //表单预览菜单
  {
    path: '/formPreview/:formId',
    name: 'formPreview',
    component: () => import('@/components/form/FormPreview'),
    props: true,
    hidden: true,
  },
  {
    path: '/sysModulePreview/:id/:appName',
    name: 'sysModulePreview',
    component: () => import('@/components/sysModule'),
    props: true,
    hidden: true,
  },
  {
    path: '/',
    component: () => import('@/components/layouts'),
    redirect: 'index',
    children: [
      {
        path: '/templateForm/:templateKey/:action',
        component: () => import('@/components/dataTemplate/TemplateForm.vue'),
        name: 'templateForm',
        hidden: true,
        props: true,
        meta: { title: '表单详情', keepAlive: true },
      },
      {
        path: '/templateForm/:templateKey/:action/:data',
        component: () => import('@/components/dataTemplate/TemplateForm.vue'),
        name: 'templateForm_withData',
        hidden: true,
        props: true,
        meta: { title: '表单列表' },
      },
      {
        path: '/templateDraftList/:tempAlias/:dataViewFlag',
        component: () => import('@/components/dataTemplate/TemplateForm.vue'),
        name: 'templateForm',
        hidden: true,
        props: true,
        meta: { title: '表单列表草稿' },
      },
      {
        path: '/appContent',
        name: 'appContent',
        component: () => import('@/views/appCenter/appContent/index.vue'),
        props: true,
        meta: { title: '应用内容' },
      },
      {
        path: '/templatePreview/:templateKey/:parameterqQuerys/:rkey',
        name: 'templatePreview',
        component: () =>
          import('@/components/dataTemplate/TemplatePreview.vue'),
        hidden: true,
        props: true,
        meta: { title: '查询数据' },
      },
    ],
  },
  // 此处增加的路由便于后续嵌套全屏展示
  {
    path: '/fullMatter',
    name: 'fullMatter',
    redirect: 'new',
    component: () => import('@/components/layouts/EmptyLayout'),
    children: [
      {
        path: 'new',
        name: 'full_new',
        component: () => import('@/views/matter/newMatter/index.vue'),
        meta: { title: '新建流程' },
      },
      {
        path: 'startProcess',
        name: 'full_startProcess',
        component: () => import('@/views/matter/StartProcess'),
        meta: { title: '流程启动' },
      },
      {
        path: 'myTask',
        name: 'full_myTask',
        component: () => import('@/views/matter/myTask/index.vue'),
        meta: { title: '我的任务' },
      },
      {
        path: 'apply',
        name: 'full_apply',
        component: () => import('@/views/matter/myRequest/index.vue'),
        meta: { title: '我的申请' },
      },
      {
        path: 'approvalForm',
        name: 'full_approvalForm',
        component: () => import('@/views/matter/ApprovalForm'),
        meta: { title: '审批表单' },
      },
      {
        path: 'circulateMatter',
        name: 'full_circulateMatter',
        component: () => import('@/views/matter/circulateMatter'),
        meta: { title: '传阅事项' },
      },
    ],
  },
  {
    path: '/external',
    name: 'external',
    component: () => import('@/components/layouts/EmptyLayout.vue'),
    children: [
      {
        path: 'approvalForm',
        name: 'external:approvalForm',
        component: () => import('@/views/external/ApprovalForm.vue'),
        meta: { title: '审批表单' },
        props: (route) => ({
          ...route.query,
        }),
      },
    ],
  },
  {
    path: '/500',
    name: '500',
    component: () => import('@/views/500'),
    hidden: true,
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/404'),
    hidden: true,
  },
]

const router = new VueRouter({
  base: publicPath,
  mode: routerMode,
  scrollBehavior: () => ({
    y: 0,
  }),
  routes: constantRoutes,
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch((err) => err)
}

export function resetRouter() {
  store.dispatch('routes/cleanRoutes')
  router.matcher = new VueRouter({
    base: publicPath,
    mode: routerMode,
    scrollBehavior: () => ({
      y: 0,
    }),
    routes: constantRoutes,
  }).matcher
}

export default router
